import { apiRequest, withToken } from './http-client';

export const getNotifications = async (token, params = {}) => {
    return apiRequest({
        method: 'get',
        url: '/notification/',
        headers: withToken(token),
        params,
    }, 'No se pudieron obtener las notificaciones');
};

export const getUnreadNotificationsCount = async (token) => {
    return apiRequest({
        method: 'get',
        url: '/notification/unread',
        headers: withToken(token),
    }, 'No se pudo obtener el conteo de notificaciones no leídas');
};

export const markNotificationAsRead = async (token, notificationId) => {
    return apiRequest({
        method: 'patch',
        url: `/notification/${notificationId}/read`,
        headers: withToken(token),
    }, 'No se pudo marcar la notificación como leída');
};

export const markAllNotificationsAsRead = async (token) => {
    return apiRequest({
        method: 'patch',
        url: '/notification/read-all',
        headers: withToken(token),
    }, 'No se pudieron marcar todas las notificaciones como leídas');
};

export const hideNotification = async (token, notificationId) => {
    return apiRequest({
        method: 'patch',
        url: `/notification/${notificationId}/hide`,
        headers: withToken(token),
    }, 'No se pudo ocultar la notificación');
};
